import React, { Component, useState } from "react";
import "./PlanTrips.css";
import { Helmet } from "react-helmet";
import NewHeader from "../NewHeader/NewHeader";
import EmptyImage from "../../assets/images/Empty.png";
import CancelledImage from "../../assets/images/Cancelled.png";
import Completed from "../../assets/images/completed-empty.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faEuroSign,
} from "@fortawesome/free-solid-svg-icons";
// import ReactHtmlParser from "react-html-parser";
import {
  // getUpcomingBooking,
  // getCancelledBooking,
  // getCompletedBooking,
  CancelBookingConfirm,
  CancelBookingConfirmHs,
  CancelBookingConfirmHl,
  // getExprerianceUpcomingBooking,
  // getExprerianceCancelledBooking,
  // getExprerianceCompletedBooking,
  CancelBookingConfirmHsTour,
  getExprerianceAgentBooking,
  // getExprerianceAgentBookingShowingPagination,
  getAgentCommissionDetails,
  getCustomerLogin,
  getUpComingBookingAPI,
  packageCancellationAPI,
  getCancelledBookingAPI,
  getCompletedBookingAPI,
} from "../axios";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
// import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
// import { PDFViewer } from "@react-pdf/renderer";
// import ReactPDF from "@react-pdf/renderer";
import { pdf } from "@react-pdf/renderer";
import Invoice from "./Invoice/Invoice";
import InvoiceAcco from "./InvoiceAcco/Invoice";
import InvoiceAgent from "./InvoiceAgent/Invoice";
import BookingAgent from "./BookingAgent/Invoice";
import BackDropComponent from "../AdminPackageDetails/PackageShowcase/BackDropComponent";
import { packageForMyBookingFunc } from "../AdminPackageDetails/PackageShowcase/commonFunction";
// import invoice from "./Invoice/invoice_data";
//import InfiniteScroll from "./InfiniteScroll";
//import InfiniteScroll from './InfiniteScrollNew';
//import InfiniteScroll from './ScrollComponent';
// import { QueryClient } from "react-query";

// const styleH1 = {
//   fontSize: "15px",
//   textAlign: "center",
//   color: "red",
// };

// const queryClient = new QueryClient();
// const styles = StyleSheet.create({
//   page: {
//     flexDirection: "row",
//     backgroundColor: "#E4E4E4",
//   },
//   section: {
//     margin: 10,
//     padding: 10,
//     flexGrow: 1,
//   },
// });
// Create Document Component
// const MyDocument = (props) => (
//   // <Document>
//   //   <Page size="A4" style={styles.page}>
//   //     <View style={styles.section}>
//   //       <Text>Section #1</Text>
//   //     </View>
//   //     <View style={styles.section}>
//   //       <Text>Section #2</Text>
//   //     </View>
//   //   </Page>
//   // </Document>

//   <Invoice invoice={props} />

// );document, fileName

const PaymentVoucherDownload = ({ pdfDocument, fileName, paymentVoucher }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      // Generate PDF blob
      const blob = await pdf(pdfDocument).toBlob();

      // Create download link
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a"); // No conflict now
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
    setLoading(false);
  };

  return (
    <span className="text-danger" onClick={handleDownload} disabled={loading} style={{ cursor: "pointer" }}>
      {loading ? "Generating PDF..." : `Download ${paymentVoucher ? "Payment" : "Booking"} Voucher`}
    </span>
  );
};
class PlanTrips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //  plannedTrips: false,
      Agent: true,
      upcoming: false,
      cancelled: false,
      Completed: false,
      ChangeColor: "reviewPlanned",
      upcomingData: null,
      cancelledData: null,
      completedData: null,
      ChangeColorNew: "tripStatusContainer reviewPlannedNew",
      upcomingTourData: null,
      cancelledTourData: null,
      completedTourData: null,
      agentData: null,
      Commission: "",
      AgentDetails: "",
      //Scrollview: "infiniteScroll",
      permissionArray: [],
      makebookingArray: ["make", "administrator"],
      cancelbookingArray: ["cancel", "administrator"],
      backDrop: false
    };
  }

  openBackDrop = () => {
    this.setState({ backDrop: true });
  }

  closeBackDrop = () => {
    this.setState({ backDrop: false });
  }

  PlannedChange = () => {
    this.setState({ plannedTrips: true });
    this.setState({ upcoming: false });
    this.setState({ cancelled: false });
    this.setState({ Completed: false });
    this.setState({ Agent: false });
    this.setState({ ChangeColor: "reviewPlanned" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewPlannedNew" });
  };

  upcomingChange = () => {
    this.setState({ plannedTrips: false });
    this.setState({ upcoming: true });
    this.setState({ cancelled: false });
    this.setState({ Completed: false });
    this.setState({ Agent: false });
    this.setState({ ChangeColor: "reviewUpcoming" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewUpcomingNew" });

    const userArr = localStorage.getItem("userDetails");
    const userArrNew = JSON.parse(userArr);
    const customer_id = userArrNew?.agent_id;
    // let booking_status = 1;
    getUpComingBookingAPI(customer_id).then(
      // getUpcomingBooking(customer_id, booking_status).then(
      (data) => {
        this.setState({ upcomingData: data });
      },
      (error) => { }
    );

    // getExprerianceUpcomingBooking(customer_id, booking_status).then(
    //   (data) => {
    //     this.setState({ upcomingTourData: data });
    //   },
    //   (error) => { }
    // );
  };

  successCancelled = () => {
    this.upcomingChange();
    this.closeBackDrop();
    alert("SuccessFully Cancelled");
  }

  cancelledChange = () => {
    this.setState({ plannedTrips: false });
    this.setState({ upcoming: false });
    this.setState({ cancelled: true });
    this.setState({ Completed: false });
    this.setState({ Agent: false });
    this.setState({ ChangeColor: "reviewCancelled" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewCancelledNew" });

    const userArr = localStorage.getItem("userDetails");
    const userArrNew = JSON.parse(userArr);
    const customer_id = userArrNew?.agent_id;
    // let booking_status = 3;
    // getCancelledBooking(customer_id, booking_status).then(
    getCancelledBookingAPI(customer_id).then(
      (data) => {
        this.setState({ cancelledData: data });
      },
      (error) => { }
    );

    //Expreriance Cancelled
    // getExprerianceCancelledBooking(customer_id, booking_status).then(
    //   (data) => {
    //     this.setState({ cancelledTourData: data });
    //   },
    //   (error) => { }
    // );
  };

  CompletedChange = () => {
    this.setState({ plannedTrips: false });
    this.setState({ upcoming: false });
    this.setState({ cancelled: false });
    this.setState({ Completed: true });
    this.setState({ Agent: false });
    this.setState({ ChangeColor: "reviewCompleted" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewCompletedNew" });

    const userArr = localStorage.getItem("userDetails");
    const userArrNew = JSON.parse(userArr);
    const customer_id = userArrNew?.agent_id;
    // let booking_status = 1;
    // getCompletedBooking(customer_id, booking_status).then(
    getCompletedBookingAPI(customer_id).then(
      (data) => {
        this.setState({ completedData: data });
      },
      (error) => { }
    );
    //Expreriance Completed
    // getExprerianceCompletedBooking(customer_id, booking_status).then(
    //   (data) => {
    //     this.setState({ completedTourData: data });
    //   },
    //   (error) => { }
    // );
  };

  AgentChange = () => {
    this.setState({ plannedTrips: false });
    this.setState({ upcoming: false });
    this.setState({ cancelled: false });
    this.setState({ Completed: false });
    this.setState({ Agent: true });
    this.setState({ ChangeColor: "reviewUpcoming" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewUpcomingNew" });

    const userArr = localStorage.getItem("userDetails");
    const userArrNew = JSON.parse(userArr);
    const customer_id = userArrNew?.agent_id;
    let booking_status = 1;

    getCustomerLogin(userArrNew.email).then(
      (data) => {

        this.setState({ AgentDetails: data?.agent });
      },
      (error) => { }
    );
    getExprerianceAgentBooking(customer_id, booking_status).then(
      (data) => {
        this.setState({ agentData: data });
      },
      (error) => { }
    );

    // getExprerianceAgentBookingShowingPagination().then(
    //   (data) => {

    //     this.setState({ agentData: data });
    //   },
    //   (error) => { }
    // );

    getAgentCommissionDetails(customer_id).then(
      (data) => {
        this.setState({ Commission: data });
      },
      (error) => { }
    );
  };

  componentDidMount() {
    this.setState({ plannedTrips: false });
    this.setState({ upcoming: false });
    this.setState({ cancelled: false });
    this.setState({ Completed: false });
    this.setState({ Agent: true });
    this.setState({ ChangeColor: "reviewUpcoming" });
    this.setState({ ChangeColorNew: "tripStatusContainer reviewUpcomingNew" });

    const userArr = localStorage.getItem("userDetails");
    const userArrNew = JSON.parse(userArr);
    const customer_id = userArrNew?.agent_id;
    let booking_status = 1;

    getCustomerLogin(userArrNew.email).then(
      (data) => {
        this.setState({ AgentDetails: data?.agent });
        if (data?.user != "nouser" && data?.user?.permission) {
          const permissionArrayData = data?.user?.permission.split(",");
          this.setState({ permissionArray: permissionArrayData });
        } else {
          this.setState({ permissionArray: 'agent' });
        }
      },
      (error) => { }
    );
    getExprerianceAgentBooking(customer_id, booking_status).then(
      (data) => {
        this.setState({ agentData: data });
      },
      (error) => { }
    );

    // getExprerianceAgentBookingShowingPagination().then(
    //   (data) => {

    //     this.setState({ agentData: data });
    //   },
    //   (error) => { }
    // );

    getAgentCommissionDetails(customer_id).then(
      (data) => {
        this.setState({ Commission: data });
      },
      (error) => { }
    );
  }

  CancelBookingConfirmButton = (Locator, CancellationPolicy) => {
    const isConfirm = window.confirm("Are you sure want to cancel?");
    if (!isConfirm) return;

    this.openBackDrop();
    let CurrentDate = new Date();
    let CurrentDateNew = moment(CurrentDate).format("YYYY-MM-DD");

    let PercentagePrice = 0;
    CancellationPolicy.map((item, key) => {
      let d1 = new Date("2021-05-10");
      let d2 = new Date(item.attributes.DateFrom);

      if (d1.getTime() >= d2.getTime()) {
        PercentagePrice = item.attributes.PercentPrice;
        return PercentagePrice;
      }
    });

    CancelBookingConfirm(Locator, PercentagePrice).then(
      (data) => {
        // this.setState({ completedData: data });
        this.successCancelled();
      },
      (error) => { }
    );
  };

  upcomingBookingCancelButton = (id) => {
    const isConfirm = window.confirm("Are you sure want to cancel?");
    if (!isConfirm) return;

    this.openBackDrop();

    packageCancellationAPI(id).then(
      (data) => {
        // this.setState({ completedData: data });
        this.successCancelled();
      },
      (error) => { }
    );

  };

  //Hotal HS Cancellation

  CancelBookingConfirmButtonHs = (hsbooking_id) => {
    const isConfirm = window.confirm("Are you sure want to cancel?");
    if (!isConfirm) return;

    this.openBackDrop();
    CancelBookingConfirmHs(hsbooking_id).then(
      (data) => {
        this.successCancelled();
      },
      (error) => { }
    );
  };

  CancelBookingConfirmButtonHl = (hsbooking_id) => {
    const isConfirm = window.confirm("Are you sure want to cancel?");
    if (!isConfirm) return;

    this.openBackDrop();
    CancelBookingConfirmHl(hsbooking_id).then(
      (data) => {
        this.successCancelled();
      },
      (error) => { }
    );
  };

  //Tour HS Cancellation
  CancelBookingConfirmButtonHsTour = (hstourbooking_id) => {
    const isConfirm = window.confirm("Are you sure want to cancel?");
    if (!isConfirm) return;

    this.openBackDrop();
    CancelBookingConfirmHsTour(hstourbooking_id).then(
      (data) => {
        this.successCancelled();
      },
      (error) => { }
    );
  };

  starsCount = (HotelCategory) => {
    if (HotelCategory == 1) {
      return (
        <>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
        </>
      );
    } else if (HotelCategory == 2) {
      return (
        <>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
        </>
      );
    } else if (HotelCategory == 3) {
      return (
        <>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
        </>
      );
    } else if (HotelCategory == 4) {
      return (
        <>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
        </>
      );
    } else if (HotelCategory == 5) {
      return (
        <>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
          <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
        </>
      );
    }
  };

  render() {
    return (
      <div>
        <Helmet>
          <title> Plan your Best Trip @ Holiday Seychelles</title>
          <meta
            name="description"
            content="Plan your honeymoon in one of the beautiful places in the world - Holiday Seychelles."
          />
          <meta
            name="keywords"
            content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
          />
        </Helmet>
        <h1 style={{ color: "#fff" }}>
          {" "}
          Plan your Best Trip @ Holiday Seychelles
        </h1>
        <NewHeader page={"inner_listing"} />
        <div className="TripContainer" id="container">
          <div className={this.state.ChangeColor} style={{ marginTop: "-5px" }}>
            <div className="landingContainer">
              <h4>My Trips</h4>
            </div>
          </div>

          <div className={this.state.ChangeColorNew}>
            <div className="tripStatusWrap">
              <ul>
                <li
                  className={this.state.Agent && "active ColorUpcoming"}
                  onClick={this.AgentChange}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabUpcoming cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                        My Bookings
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
                <li
                  className={
                    this.state.plannedTrips && "active ColorPlannedTrips"
                  }
                  onClick={this.PlannedChange}
                  style={{ display: "none" }}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabUpcoming cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                        Planned Trips
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
                <li
                  className={this.state.upcoming && "active ColorUpcoming"}
                  onClick={this.upcomingChange}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabUpcoming cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">Upcoming</span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
                <li
                  className={this.state.cancelled && "active ColorCancelled"}
                  onClick={this.cancelledChange}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabCancelled--inactive cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                        Cancelled
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
                <li
                  className={this.state.Completed && "active ColorCompleted"}
                  onClick={this.CompletedChange}
                >
                  <a className="mytripmakeFlex">
                    <span className="cm__myTripSprt--tabCompleted--inactive cm__myTripSprt appendRight10"></span>
                    <span className="tripStatusWrap__statusText">
                      <span className="font16 latoBlack capText">
                        Completed
                      </span>
                      <span className="font12 latoBold"></span>
                    </span>
                  </a>
                </li>
              </ul>
              <div className="txtFild "></div>
            </div>
          </div>
          <div className="contentWrapper myTrips">
            <div>
              <div className="tripListingWrap">
                <div>
                  {this.state.plannedTrips == true ? (
                    <div className="myTripLstngLobCrd forPlanned">
                      <div className="emptyErr">
                        <div className="emptyErr--imgCont">
                          <img src={EmptyImage} alt="Upcoming Image" />
                        </div>
                        <div>
                          <p className="emptyErr--heading font22 latoBlack appendBottom15">
                            Looks empty, you've no planned trips.
                          </p>
                          <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                            When you book a trip, you will see your itinerary
                            here.
                          </p>
                          <p>
                            <a href="/home">
                              <button className="font14 latoBold myTripBtn myTripBtn--primary ">
                                Plan a trip
                              </button>
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {this.state.upcoming == true ? (
                    <div className="myTripLstngLobCrd forUpcoming">
                      {this.state.upcomingData == "noUpcoming"
                        // && this.state.upcomingTourData == "noUpcoming" 
                        ? (
                          <div className="emptyErr">
                            <div className="emptyErr--imgCont">
                              <img src={EmptyImage} alt="Upcoming Image" />
                            </div>
                            <div>
                              <p className="emptyErr--heading font22 latoBlack appendBottom15">
                                Looks empty, you've no upcoming bookings.
                              </p>
                              <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                                When you book a trip, you will see your itinerary
                                here.
                              </p>
                              <p>
                                <a href="/home">
                                  <button className="font14 latoBold myTripBtn myTripBtn--primary ">
                                    Plan a trip
                                  </button>
                                </a>
                              </p>
                            </div>
                          </div>
                        ) : (
                          <>
                            {this.state.upcomingData == null ? (
                              <>
                                <div
                                  className="Container-Tile h-auto"
                                // style={{ height: 250 }}
                                >
                                  <div className="ContainerFlex">
                                    <div
                                      className="ContainerImage"
                                      style={{ padding: "15px 10px 10px 10px" }}
                                    >
                                      <Skeleton
                                        style={{ width: "100%", height: "165px" }}
                                      />
                                    </div>
                                    <div
                                      className="ContainerContent"
                                      style={{ padding: "10px 10px 10px 40px" }}
                                    >
                                      <div
                                        className="nameContainer"
                                        style={{ width: "100%" }}
                                      >
                                        <div className="paymakeFlex appendBottom5">
                                          <h3 className="latoBlack font22 blackText">
                                            <Skeleton
                                              style={{ width: "200px" }}
                                            />
                                          </h3>
                                          <span
                                            className="sRating"
                                            style={{
                                              display: "inline-flex",
                                              marginTop: "5px",
                                              marginLeft: "10px",
                                            }}
                                          >
                                            <Skeleton
                                              style={{ width: "100px" }}
                                            />
                                          </span>
                                        </div>
                                        <p>
                                          <Skeleton style={{ width: "300px" }} />
                                        </p>
                                        <h3
                                          className="latoBlack font22 blackText"
                                          style={{
                                            marginTop: 10,
                                            fontSize: 18,
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <Skeleton style={{ width: "150px" }} />
                                        </h3>

                                        <div class="chkContBooking">
                                          <div class="chkCont__col">
                                            <div class="paymakeFlex column">
                                              <span class="font10 grayText appendBottom3">
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                              <span class="latoBlack font24 blackText appendBottom3">
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                              <span class="font10 grayText 444">
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                            </div>
                                            <div class="chkCont__night">
                                              <span>
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                            </div>
                                            <div class="paymakeFlex column">
                                              <span class="font10 grayText appendBottom3">
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                              <span class="latoBlack font24 blackText appendBottom3">
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                              <span class="font10 grayText">
                                                <Skeleton
                                                  style={{ width: 150 }}
                                                />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                {this.state.upcomingData.agent && (
                                  <>
                                    {" "}
                                    {this.state.upcomingData.agent.agentbookingArr.map(
                                      (item, newindex) => {
                                        const Status = item.booking_status;
                                        let StatusMsg = "";
                                        if (Status == 1) {
                                          StatusMsg = "Booking confirmed";
                                        }
                                        const AgentbookingID = item.id;
                                        const totalAmountAgent = parseFloat(
                                          item.total.slice(5, 13)
                                        );
                                        const commistionPrice = parseFloat(
                                          item.commission_price
                                        );
                                        const MainPrice = parseFloat(
                                          totalAmountAgent + commistionPrice
                                        );

                                        let JsonStatePDFAcco = {
                                          booking_amount: MainPrice,
                                          paid_amount: totalAmountAgent,
                                          booking_refrence_id:
                                            item.booking_refrence_id,
                                          b_date: item.booking_date,
                                          numberof_night: 2,
                                          child: item.child,
                                          status: StatusMsg,
                                          agentdetails: this.state.AgentDetails,
                                        };
                                        const propertypdf = JSON.stringify(
                                          JsonStatePDFAcco
                                        );

                                        const packageDetails = packageForMyBookingFunc(item?.child);
                                        const isPackage = packageDetails.is_package;
                                        const package_name = packageDetails.package_name;
                                        let packageBookingID = null;

                                        if (isPackage) {
                                          packageBookingID = packageDetails.agent_booking_id;
                                        } else {
                                          packageBookingID = item?.child[0].id
                                        }

                                        return (
                                          <>
                                            <div className="Container-Tile h-auto">
                                              <div class="ContainerFlex">
                                                <div class="row">
                                                  <div class="col-sm-8">
                                                    <div class="container">
                                                      <div class="row">
                                                        <div class="pricing-details">
                                                          <div className="price-breakup">
                                                            <div className="price-header">
                                                              {isPackage && <h6 className="text-black mb-1">Package Name: <span>{package_name}</span></h6>}
                                                              <h6
                                                                style={{
                                                                  color:
                                                                    "black",
                                                                }}
                                                              >
                                                                <span>
                                                                  Agent Booking
                                                                  Ref No:-{" "}
                                                                  {
                                                                    item.booking_refrence_id
                                                                  }
                                                                </span>{" "}
                                                                <span
                                                                  style={{
                                                                    float:
                                                                      "right",
                                                                  }}
                                                                >
                                                                  Booking Date-{" "}
                                                                  {moment(
                                                                    item.booking_date
                                                                  ).format(
                                                                    "D MMM Y"
                                                                  )}
                                                                </span>
                                                              </h6>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="container px-4 text-center">
                                                          {/* <div class="row gx-5">
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="paymentVoucher.pdf"
                                                                pdfDocument={<InvoiceAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                                paymentVoucher
                                                              />
                                                            </div>
                                                          </div>
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="bookingVoucher.pdf"
                                                                pdfDocument={<BookingAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div> */}
                                                        </div>
                                                        <div
                                                          style={{
                                                            height: "180px",
                                                            overflowY: "auto",
                                                          }}
                                                        >
                                                          <table className="table">
                                                            <thead className="thead-dark">
                                                              <tr>
                                                                <th scope="col">
                                                                  #
                                                                </th>
                                                                <th scope="col">
                                                                  BookingId.
                                                                </th>
                                                                <th scope="col">
                                                                  Item
                                                                </th>
                                                                <th scope="col">
                                                                  Service Date
                                                                </th>
                                                                {!isPackage &&
                                                                  <th scope="col">
                                                                    Amount
                                                                  </th>}
                                                                <th scope="col">
                                                                  Status
                                                                </th>
                                                                {!isPackage && <th scope="col">
                                                                  Action
                                                                </th>}
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {item.child !=
                                                                null &&
                                                                item.child.map(
                                                                  (
                                                                    bookingItem,
                                                                    indexNewData
                                                                  ) => {
                                                                    const Statuschild =
                                                                      bookingItem.booking_status;
                                                                    let StatusMsgChild =
                                                                      "";
                                                                    if (
                                                                      Statuschild ==
                                                                      1
                                                                    ) {
                                                                      StatusMsgChild =
                                                                        "Booking Confirmed";
                                                                    } else if (
                                                                      Statuschild ==
                                                                      3
                                                                    ) {
                                                                      StatusMsgChild =
                                                                        "Booking Cancelled";
                                                                    } else if (
                                                                      Statuschild ==
                                                                      11
                                                                    ) {
                                                                      StatusMsgChild =
                                                                        "Booking Decline";
                                                                    } else if (
                                                                      Statuschild ==
                                                                      12
                                                                    ) {
                                                                      StatusMsgChild =
                                                                        "Booking Review";
                                                                    } else if (
                                                                      Statuschild ==
                                                                      13
                                                                    ) {
                                                                      StatusMsgChild =
                                                                        "Booking Error";
                                                                    } else {
                                                                      StatusMsgChild =
                                                                        "Payment Settled but Not Booked";
                                                                    }
                                                                    let bookingRefrence =
                                                                      bookingItem.booking_refrence_id;
                                                                    if (
                                                                      bookingItem.booking_source ==
                                                                      1
                                                                    ) {
                                                                      if (
                                                                        bookingItem.ReservationLocation !=
                                                                        null
                                                                      ) {
                                                                        bookingRefrence =
                                                                          bookingItem.booking_refrence_id +
                                                                          "-" +
                                                                          bookingItem.ReservationLocation;
                                                                      } else {
                                                                        bookingRefrence =
                                                                          bookingItem.booking_refrence_id;
                                                                      }
                                                                    } else if (
                                                                      bookingItem.booking_source ==
                                                                      2
                                                                    ) {
                                                                      bookingRefrence =
                                                                        bookingItem.booking_refrence_id +
                                                                        "-" +
                                                                        bookingItem.hl_booking_id;
                                                                    }

                                                                    const bookingID = bookingItem.id;

                                                                    return (
                                                                      <tr>
                                                                        <th scope="row"> {indexNewData + 1} </th>
                                                                        <td> {bookingRefrence} </td>
                                                                        <td>
                                                                          {" "}
                                                                          {
                                                                            bookingItem.rateplan_name
                                                                          }
                                                                          (
                                                                          {
                                                                            bookingItem.item_name
                                                                          }
                                                                          )
                                                                          <br />

                                                                          {bookingItem?.pickup_transfer && (`${bookingItem.pickup_transfer} to ${bookingItem.drop_transfer}`)}

                                                                        </td>
                                                                        <td>
                                                                          {bookingItem.type ==
                                                                            "accomodation"
                                                                            ? moment(
                                                                              bookingItem.booking_checked_in
                                                                            ).format(
                                                                              "D MMM Y"
                                                                            ) +
                                                                            " - " +
                                                                            moment(
                                                                              bookingItem.booking_checked_out
                                                                            ).format(
                                                                              "D MMM Y"
                                                                            )
                                                                            : moment(
                                                                              bookingItem.tour_booking_date
                                                                            ).format(
                                                                              "D MMM Y"
                                                                            )}
                                                                        </td>
                                                                        {!isPackage && <td>
                                                                          {parseFloat(
                                                                            bookingItem.total.slice(
                                                                              5,
                                                                              13
                                                                            )
                                                                          )}
                                                                        </td>}
                                                                        <td>
                                                                          {
                                                                            StatusMsgChild
                                                                          }
                                                                          {bookingItem?.cancel_by == 1 ? (<span className="cancelled-by-admin">Admin</span>) : (<></>)}
                                                                        </td>
                                                                        {!isPackage && <td>
                                                                          <span
                                                                            className="btn btn-sm btn-danger"
                                                                            onClick={() => {
                                                                              if (this.state.permissionArray == 'agent' || this.state.cancelbookingArray.some(value => this.state.permissionArray.includes(value))) {
                                                                                if (bookingItem.hasOwnProperty("tour_operator_id")) {
                                                                                  this.CancelBookingConfirmButtonHsTour(bookingID)
                                                                                } else if (bookingItem.hasOwnProperty("property_id"))
                                                                                  if (bookingItem.booking_source == 2) {
                                                                                    this.CancelBookingConfirmButtonHl(bookingID)
                                                                                  } else if (bookingItem.booking_source == 0) {
                                                                                    this.CancelBookingConfirmButtonHs(bookingID)
                                                                                  } else if (bookingItem.booking_source == 1) {

                                                                                    const Locator =
                                                                                      bookingItem?.ReadBookingResponse
                                                                                        ?.BookingRS?.Reservations
                                                                                        ?.Reservation?.attributes
                                                                                        ?.Locator;
                                                                                    let CancellationPolicy = "";

                                                                                    const DataArrShow =
                                                                                      bookingItem?.ReadBookingResponse?.BookingRS
                                                                                        ?.Reservations?.Reservation?.Items
                                                                                        ?.HotelItem;

                                                                                    if (Array.isArray(DataArrShow)) {
                                                                                      CancellationPolicy =
                                                                                        DataArrShow[0]?.CancellationPolicy
                                                                                          ?.PolicyRules?.Rule;

                                                                                    } else {
                                                                                      CancellationPolicy = DataArrShow?.CancellationPolicy
                                                                                        ?.PolicyRules?.Rule;
                                                                                    }

                                                                                    this.CancelBookingConfirmButton(Locator, CancellationPolicy)
                                                                                  }
                                                                              }
                                                                            }}
                                                                            id="Cancel_Button"
                                                                            style={{ borderRadius: 5 }}
                                                                          >
                                                                            Cancel Booking
                                                                          </span>
                                                                        </td>}
                                                                      </tr>
                                                                    );
                                                                  }
                                                                )}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div class="col-sm-4">
                                                    <div class="pricing-details">
                                                      <div className="price-breakup">
                                                        <div className="price-header">
                                                          <h6
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            Price Details
                                                          </h6>
                                                        </div>
                                                        <div className="total-amount">
                                                          <div>
                                                            <p>Price</p>
                                                          </div>
                                                          <div>
                                                            <p
                                                              className="latoBlack font26 blackText appendBottom5"
                                                              id="hlistpg_hotel_shown_price"
                                                            >
                                                              <span>€</span>
                                                              {MainPrice.toFixed(
                                                                2
                                                              )}
                                                            </p>
                                                          </div>
                                                        </div>

                                                        <div className="taxes">
                                                          <h6
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            Less Agent Discount(
                                                            {
                                                              this.state
                                                                .Commission
                                                            }
                                                            %)
                                                          </h6>
                                                          <h6
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span>€</span>
                                                            {commistionPrice.toFixed(
                                                              2
                                                            )}
                                                          </h6>
                                                        </div>
                                                        <div className="total-amount">
                                                          <h6
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            Total Amount
                                                          </h6>
                                                          <h6
                                                            style={{
                                                              color: "red",
                                                            }}
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={faEuroSign}
                                                              style={{
                                                                fontSize:
                                                                  "14px",
                                                                marginRight:
                                                                  "5px",
                                                              }}
                                                            ></FontAwesomeIcon>
                                                            {totalAmountAgent.toFixed(
                                                              2
                                                            )}
                                                          </h6>
                                                        </div>
                                                      </div>
                                                      {isPackage && <div className="float-end mt-3">
                                                        <span
                                                          className="btn btn-sm btn-danger"
                                                          onClick={() =>
                                                            this.upcomingBookingCancelButton(packageBookingID)
                                                          }
                                                          id="Cancel_Button"
                                                          style={{ borderRadius: 5 }}
                                                        >
                                                          Cancel Booking
                                                        </span>
                                                      </div>}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        );
                                      }
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                    </div>
                  ) : (
                    <></>
                  )}

                  {this.state.cancelled == true ? (
                    <div className="myTripLstngLobCrd forCancelled">
                      {this.state.cancelledData == "noCancelled"
                        // && this.state.cancelledTourData == "noCancelled" 
                        ? (
                          <div className="emptyErr">
                            <div className="emptyErr--imgCont">
                              <img src={CancelledImage} alt="Upcoming Image" />
                            </div>
                            <div>
                              <p className="emptyErr--heading font22 latoBlack appendBottom15">
                                Looks empty, you've no cancelled bookings.
                              </p>
                              <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                                When you book a trip, you will see your itinerary
                                here.
                              </p>
                              <p>
                                <a href="/home">
                                  <button className="font14 latoBold myTripBtn myTripBtn--primary ">
                                    Plan a trip
                                  </button>
                                </a>
                              </p>
                            </div>
                          </div>
                        ) : (
                          <>
                            {this.state.cancelledData == null
                              // || this.state.cancelledTourData == null 
                              ? (
                                <>
                                  <div
                                    className="Container-Tile h-auto"
                                  // style={{ height: 250 }}
                                  >
                                    <div className="ContainerFlex">
                                      <div
                                        className="ContainerImage"
                                        style={{ padding: "15px 10px 10px 10px" }}
                                      >
                                        <Skeleton
                                          style={{ width: "100%", height: "165px" }}
                                        />
                                      </div>
                                      <div
                                        className="ContainerContent"
                                        style={{ padding: "10px 10px 10px 40px" }}
                                      >
                                        <div
                                          className="nameContainer"
                                          style={{ width: "100%" }}
                                        >
                                          <div className="paymakeFlex appendBottom5">
                                            <h3 className="latoBlack font22 blackText">
                                              <Skeleton
                                                style={{ width: "200px" }}
                                              />
                                            </h3>
                                            <span
                                              className="sRating"
                                              style={{
                                                display: "inline-flex",
                                                marginTop: "5px",
                                                marginLeft: "10px",
                                              }}
                                            >
                                              <Skeleton
                                                style={{ width: "100px" }}
                                              />
                                            </span>
                                          </div>
                                          <p>
                                            <Skeleton style={{ width: "300px" }} />
                                          </p>
                                          <h3
                                            className="latoBlack font22 blackText"
                                            style={{
                                              marginTop: 10,
                                              fontSize: 18,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            <Skeleton style={{ width: "150px" }} />
                                          </h3>

                                          <div class="chkContBooking">
                                            <div class="chkCont__col">
                                              <div class="paymakeFlex column">
                                                <span class="font10 grayText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="latoBlack font24 blackText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="font10 grayText 444">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                              </div>
                                              <div class="chkCont__night">
                                                <span>
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                              </div>
                                              <div class="paymakeFlex column">
                                                <span class="font10 grayText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="latoBlack font24 blackText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="font10 grayText">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {this.state.cancelledData.agent && (
                                    <>
                                      {" "}
                                      {this.state.cancelledData.agent.agentbookingArr.map(
                                        (item, newindex) => {
                                          const Status = item.booking_status;
                                          let StatusMsg = "";
                                          if (Status == 1) {
                                            StatusMsg = "Booking confirmed";
                                          }
                                          const AgentbookingID = item.id;
                                          const totalAmountAgent = parseFloat(
                                            item.total.slice(5, 13)
                                          );
                                          const commistionPrice = parseFloat(
                                            item.commission_price
                                          );
                                          const MainPrice = parseFloat(
                                            totalAmountAgent + commistionPrice
                                          );

                                          let JsonStatePDFAcco = {
                                            booking_amount: MainPrice,
                                            paid_amount: totalAmountAgent,
                                            booking_refrence_id:
                                              item.booking_refrence_id,
                                            b_date: item.booking_date,
                                            numberof_night: 2,
                                            child: item.child,
                                            status: StatusMsg,
                                            agentdetails: this.state.AgentDetails,
                                          };
                                          const propertypdf = JSON.stringify(
                                            JsonStatePDFAcco
                                          );

                                          const packageDetails = packageForMyBookingFunc(item?.child);
                                          const isPackage = packageDetails.is_package;
                                          const package_name = packageDetails.package_name;

                                          return (
                                            <>
                                              <div className="Container-Tile h-auto">
                                                <div class="ContainerFlex">
                                                  <div class="row">
                                                    <div class="col-sm-8">
                                                      <div class="container">
                                                        <div class="row">
                                                          <div class="pricing-details">
                                                            <div className="price-breakup">
                                                              <div className="price-header">
                                                                {isPackage && <h6 className="text-black mb-1">Package Name: <span>{package_name}</span></h6>}
                                                                <h6
                                                                  style={{
                                                                    color:
                                                                      "black",
                                                                  }}
                                                                >
                                                                  <span>
                                                                    Agent Booking
                                                                    Ref No:-{" "}
                                                                    {
                                                                      item.booking_refrence_id
                                                                    }
                                                                  </span>{" "}
                                                                  <span
                                                                    style={{
                                                                      float:
                                                                        "right",
                                                                    }}
                                                                  >
                                                                    Booking Date-{" "}
                                                                    {moment(
                                                                      item.booking_date
                                                                    ).format(
                                                                      "D MMM Y"
                                                                    )}
                                                                  </span>
                                                                </h6>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="container px-4 text-center">
                                                            {/* <div class="row gx-5">
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="paymentVoucher.pdf"
                                                                pdfDocument={<InvoiceAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                                paymentVoucher
                                                              />
                                                            </div>
                                                          </div>
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="bookingVoucher.pdf"
                                                                pdfDocument={<BookingAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div> */}
                                                          </div>
                                                          <div
                                                            style={{
                                                              height: "180px",
                                                              overflowY: "auto",
                                                            }}
                                                          >
                                                            <table className="table">
                                                              <thead className="thead-dark">
                                                                <tr>
                                                                  <th scope="col">
                                                                    #
                                                                  </th>
                                                                  <th scope="col">
                                                                    BookingId.
                                                                  </th>
                                                                  <th scope="col">
                                                                    Item
                                                                  </th>
                                                                  <th scope="col">
                                                                    Service Date
                                                                  </th>
                                                                  {!isPackage &&
                                                                    <th scope="col">
                                                                      Amount
                                                                    </th>}
                                                                  <th scope="col">
                                                                    Status
                                                                  </th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {item.child !=
                                                                  null &&
                                                                  item.child.map(
                                                                    (
                                                                      bookingItem,
                                                                      indexNewData
                                                                    ) => {
                                                                      const Statuschild =
                                                                        bookingItem.booking_status;
                                                                      let StatusMsgChild =
                                                                        "";
                                                                      if (
                                                                        Statuschild ==
                                                                        1
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Confirmed";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        3
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Cancelled";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        11
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Decline";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        12
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Review";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        13
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Error";
                                                                      } else {
                                                                        StatusMsgChild =
                                                                          "Payment Settled but Not Booked";
                                                                      }
                                                                      let bookingRefrence =
                                                                        bookingItem.booking_refrence_id;
                                                                      if (
                                                                        bookingItem.booking_source ==
                                                                        1
                                                                      ) {
                                                                        if (
                                                                          bookingItem.ReservationLocation !=
                                                                          null
                                                                        ) {
                                                                          bookingRefrence =
                                                                            bookingItem.booking_refrence_id +
                                                                            "-" +
                                                                            bookingItem.ReservationLocation;
                                                                        } else {
                                                                          bookingRefrence =
                                                                            bookingItem.booking_refrence_id;
                                                                        }
                                                                      } else if (
                                                                        bookingItem.booking_source ==
                                                                        2
                                                                      ) {
                                                                        bookingRefrence =
                                                                          bookingItem.booking_refrence_id +
                                                                          "-" +
                                                                          bookingItem.hl_booking_id;
                                                                      }

                                                                      return (
                                                                        <tr>
                                                                          <th scope="row"> {indexNewData + 1} </th>
                                                                          <td> {bookingRefrence} </td>
                                                                          <td>
                                                                            {" "}
                                                                            {
                                                                              bookingItem.rateplan_name
                                                                            }
                                                                            (
                                                                            {
                                                                              bookingItem.item_name
                                                                            }
                                                                            )
                                                                            <br />

                                                                            {bookingItem?.pickup_transfer && (`${bookingItem.pickup_transfer} to ${bookingItem.drop_transfer}`)}

                                                                          </td>
                                                                          <td>
                                                                            {bookingItem.type ==
                                                                              "accomodation"
                                                                              ? moment(
                                                                                bookingItem.booking_checked_in
                                                                              ).format(
                                                                                "D MMM Y"
                                                                              ) +
                                                                              " - " +
                                                                              moment(
                                                                                bookingItem.booking_checked_out
                                                                              ).format(
                                                                                "D MMM Y"
                                                                              )
                                                                              : moment(
                                                                                bookingItem.tour_booking_date
                                                                              ).format(
                                                                                "D MMM Y"
                                                                              )}
                                                                          </td>
                                                                          {!isPackage && <td>
                                                                            {parseFloat(
                                                                              bookingItem.total.slice(
                                                                                5,
                                                                                13
                                                                              )
                                                                            )}
                                                                          </td>}
                                                                          <td>
                                                                            {
                                                                              StatusMsgChild
                                                                            }
                                                                            {bookingItem?.cancel_by == 1 ? (<span className="cancelled-by-admin">Admin</span>) : (<></>)}
                                                                          </td>
                                                                        </tr>
                                                                      );
                                                                    }
                                                                  )}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="col-sm-4">
                                                      <div class="pricing-details">
                                                        <div className="price-breakup">
                                                          <div className="price-header">
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              Price Details
                                                            </h6>
                                                          </div>
                                                          <div className="total-amount">
                                                            <div>
                                                              <p>Price</p>
                                                            </div>
                                                            <div>
                                                              <p
                                                                className="latoBlack font26 blackText appendBottom5"
                                                                id="hlistpg_hotel_shown_price"
                                                              >
                                                                <span>€</span>
                                                                {MainPrice.toFixed(
                                                                  2
                                                                )}
                                                              </p>
                                                            </div>
                                                          </div>

                                                          <div className="taxes">
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              Less Agent Discount(
                                                              {
                                                                this.state
                                                                  .Commission
                                                              }
                                                              %)
                                                            </h6>
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              <span>€</span>
                                                              {commistionPrice.toFixed(
                                                                2
                                                              )}
                                                            </h6>
                                                          </div>
                                                          <div className="total-amount">
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              Total Amount
                                                            </h6>
                                                            <h6
                                                              style={{
                                                                color: "red",
                                                              }}
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={faEuroSign}
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  marginRight:
                                                                    "5px",
                                                                }}
                                                              ></FontAwesomeIcon>
                                                              {totalAmountAgent.toFixed(
                                                                2
                                                              )}
                                                            </h6>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                          </>
                        )}
                    </div>
                  ) : (
                    <> </>
                  )}

                  {this.state.Completed == true ? (
                    <div className="myTripLstngLobCrd forCompleted">
                      {this.state.completedData == "noCompleted"
                        // && this.state.completedTourData == "noCompleted" 
                        ? (
                          <div className="emptyErr">
                            <div className="emptyErr--imgCont">
                              <img src={Completed} alt="Upcoming Image" />
                            </div>
                            <div>
                              <p className="emptyErr--heading font22 latoBlack appendBottom15">
                                Looks empty, you've no completed bookings.
                              </p>
                              <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                                When you book a trip, you will see your itinerary
                                here.
                              </p>
                              <p>
                                <a href="/home">
                                  <button className="font14 latoBold myTripBtn myTripBtn--primary ">
                                    Plan a trip
                                  </button>
                                </a>
                              </p>
                            </div>
                          </div>
                        ) : (
                          <>
                            {this.state.completedData == null
                              // || this.state.completedTourData == null 
                              ? (
                                <>
                                  <div
                                    className="Container-Tile h-auto"
                                  // style={{ height: 250 }}
                                  >
                                    <div className="ContainerFlex">
                                      <div
                                        className="ContainerImage"
                                        style={{ padding: "15px 10px 10px 10px" }}
                                      >
                                        <Skeleton
                                          style={{ width: "100%", height: "165px" }}
                                        />
                                      </div>
                                      <div
                                        className="ContainerContent"
                                        style={{ padding: "10px 10px 10px 40px" }}
                                      >
                                        <div
                                          className="nameContainer"
                                          style={{ width: "100%" }}
                                        >
                                          <div className="paymakeFlex appendBottom5">
                                            <h3 className="latoBlack font22 blackText">
                                              <Skeleton
                                                style={{ width: "200px" }}
                                              />
                                            </h3>
                                            <span
                                              className="sRating"
                                              style={{
                                                display: "inline-flex",
                                                marginTop: "5px",
                                                marginLeft: "10px",
                                              }}
                                            >
                                              <Skeleton
                                                style={{ width: "100px" }}
                                              />
                                            </span>
                                          </div>
                                          <p>
                                            <Skeleton style={{ width: "300px" }} />
                                          </p>
                                          <h3
                                            className="latoBlack font22 blackText"
                                            style={{
                                              marginTop: 10,
                                              fontSize: 18,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            <Skeleton style={{ width: "150px" }} />
                                          </h3>

                                          <div class="chkContBooking">
                                            <div class="chkCont__col">
                                              <div class="paymakeFlex column">
                                                <span class="font10 grayText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="latoBlack font24 blackText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="font10 grayText 444">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                              </div>
                                              <div class="chkCont__night">
                                                <span>
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                              </div>
                                              <div class="paymakeFlex column">
                                                <span class="font10 grayText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="latoBlack font24 blackText appendBottom3">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                                <span class="font10 grayText">
                                                  <Skeleton
                                                    style={{ width: 150 }}
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {this.state.completedData.agent && (
                                    <>
                                      {" "}
                                      {this.state.completedData.agent.agentbookingArr.map(
                                        (item, newindex) => {
                                          const Status = item.booking_status;
                                          let StatusMsg = "";
                                          if (Status == 1) {
                                            StatusMsg = "Booking confirmed";
                                          }
                                          const AgentbookingID = item.id;
                                          const totalAmountAgent = parseFloat(
                                            item.total.slice(5, 13)
                                          );
                                          const commistionPrice = parseFloat(
                                            item.commission_price
                                          );
                                          const MainPrice = parseFloat(
                                            totalAmountAgent + commistionPrice
                                          );

                                          let JsonStatePDFAcco = {
                                            booking_amount: MainPrice,
                                            paid_amount: totalAmountAgent,
                                            booking_refrence_id:
                                              item.booking_refrence_id,
                                            b_date: item.booking_date,
                                            numberof_night: 2,
                                            child: item.child,
                                            status: StatusMsg,
                                            agentdetails: this.state.AgentDetails,
                                          };
                                          const propertypdf = JSON.stringify(
                                            JsonStatePDFAcco
                                          );

                                          const packageDetails = packageForMyBookingFunc(item?.child);
                                          const isPackage = packageDetails.is_package;
                                          const package_name = packageDetails.package_name;

                                          return (
                                            <>
                                              <div className="Container-Tile h-auto">
                                                <div class="ContainerFlex">
                                                  <div class="row">
                                                    <div class="col-sm-8">
                                                      <div class="container">
                                                        <div class="row">
                                                          <div class="pricing-details">
                                                            <div className="price-breakup">
                                                              <div className="price-header">
                                                                {isPackage && <h6 className="text-black mb-1">Package Name: <span>{package_name}</span></h6>}
                                                                <h6
                                                                  style={{
                                                                    color:
                                                                      "black",
                                                                  }}
                                                                >
                                                                  <span>
                                                                    Agent Booking
                                                                    Ref No:-{" "}
                                                                    {
                                                                      item.booking_refrence_id
                                                                    }
                                                                  </span>{" "}
                                                                  <span
                                                                    style={{
                                                                      float:
                                                                        "right",
                                                                    }}
                                                                  >
                                                                    Booking Date-{" "}
                                                                    {moment(
                                                                      item.booking_date
                                                                    ).format(
                                                                      "D MMM Y"
                                                                    )}
                                                                  </span>
                                                                </h6>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="container px-4 text-center">
                                                            {/* <div class="row gx-5">
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="paymentVoucher.pdf"
                                                                pdfDocument={<InvoiceAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                                paymentVoucher
                                                              />
                                                            </div>
                                                          </div>
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="bookingVoucher.pdf"
                                                                pdfDocument={<BookingAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div> */}
                                                          </div>
                                                          <div
                                                            style={{
                                                              height: "180px",
                                                              overflowY: "auto",
                                                            }}
                                                          >
                                                            <table className="table">
                                                              <thead className="thead-dark">
                                                                <tr>
                                                                  <th scope="col">
                                                                    #
                                                                  </th>
                                                                  <th scope="col">
                                                                    BookingId.
                                                                  </th>
                                                                  <th scope="col">
                                                                    Item
                                                                  </th>
                                                                  <th scope="col">
                                                                    Service Date
                                                                  </th>
                                                                  {!isPackage &&
                                                                    <th scope="col">
                                                                      Amount
                                                                    </th>}
                                                                  <th scope="col">
                                                                    Status
                                                                  </th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                {item.child !=
                                                                  null &&
                                                                  item.child.map(
                                                                    (
                                                                      bookingItem,
                                                                      indexNewData
                                                                    ) => {
                                                                      const Statuschild =
                                                                        bookingItem.booking_status;
                                                                      let StatusMsgChild =
                                                                        "";
                                                                      if (
                                                                        Statuschild ==
                                                                        1
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Confirmed";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        3
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Cancelled";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        11
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Decline";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        12
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Review";
                                                                      } else if (
                                                                        Statuschild ==
                                                                        13
                                                                      ) {
                                                                        StatusMsgChild =
                                                                          "Booking Error";
                                                                      } else {
                                                                        StatusMsgChild =
                                                                          "Payment Settled but Not Booked";
                                                                      }
                                                                      let bookingRefrence =
                                                                        bookingItem.booking_refrence_id;
                                                                      if (
                                                                        bookingItem.booking_source ==
                                                                        1
                                                                      ) {
                                                                        if (
                                                                          bookingItem.ReservationLocation !=
                                                                          null
                                                                        ) {
                                                                          bookingRefrence =
                                                                            bookingItem.booking_refrence_id +
                                                                            "-" +
                                                                            bookingItem.ReservationLocation;
                                                                        } else {
                                                                          bookingRefrence =
                                                                            bookingItem.booking_refrence_id;
                                                                        }
                                                                      } else if (
                                                                        bookingItem.booking_source ==
                                                                        2
                                                                      ) {
                                                                        bookingRefrence =
                                                                          bookingItem.booking_refrence_id +
                                                                          "-" +
                                                                          bookingItem.hl_booking_id;
                                                                      }

                                                                      return (
                                                                        <tr>
                                                                          <th scope="row"> {indexNewData + 1} </th>
                                                                          <td> {bookingRefrence} </td>
                                                                          <td>
                                                                            {" "}
                                                                            {
                                                                              bookingItem.rateplan_name
                                                                            }
                                                                            (
                                                                            {
                                                                              bookingItem.item_name
                                                                            }
                                                                            )
                                                                            <br />

                                                                            {bookingItem?.pickup_transfer && (`${bookingItem.pickup_transfer} to ${bookingItem.drop_transfer}`)}

                                                                          </td>
                                                                          <td>
                                                                            {bookingItem.type ==
                                                                              "accomodation"
                                                                              ? moment(
                                                                                bookingItem.booking_checked_in
                                                                              ).format(
                                                                                "D MMM Y"
                                                                              ) +
                                                                              " - " +
                                                                              moment(
                                                                                bookingItem.booking_checked_out
                                                                              ).format(
                                                                                "D MMM Y"
                                                                              )
                                                                              : moment(
                                                                                bookingItem.tour_booking_date
                                                                              ).format(
                                                                                "D MMM Y"
                                                                              )}
                                                                          </td>
                                                                          {!isPackage && <td>
                                                                            {parseFloat(
                                                                              bookingItem.total.slice(
                                                                                5,
                                                                                13
                                                                              )
                                                                            )}
                                                                          </td>}
                                                                          <td>
                                                                            {
                                                                              StatusMsgChild
                                                                            }
                                                                            {bookingItem?.cancel_by == 1 ? (<span className="cancelled-by-admin">Admin</span>) : (<></>)}
                                                                          </td>
                                                                        </tr>
                                                                      );
                                                                    }
                                                                  )}
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="col-sm-4">
                                                      <div class="pricing-details">
                                                        <div className="price-breakup">
                                                          <div className="price-header">
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              Price Details
                                                            </h6>
                                                          </div>
                                                          <div className="total-amount">
                                                            <div>
                                                              <p>Price</p>
                                                            </div>
                                                            <div>
                                                              <p
                                                                className="latoBlack font26 blackText appendBottom5"
                                                                id="hlistpg_hotel_shown_price"
                                                              >
                                                                <span>€</span>
                                                                {MainPrice.toFixed(
                                                                  2
                                                                )}
                                                              </p>
                                                            </div>
                                                          </div>

                                                          <div className="taxes">
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              Less Agent Discount(
                                                              {
                                                                this.state
                                                                  .Commission
                                                              }
                                                              %)
                                                            </h6>
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              <span>€</span>
                                                              {commistionPrice.toFixed(
                                                                2
                                                              )}
                                                            </h6>
                                                          </div>
                                                          <div className="total-amount">
                                                            <h6
                                                              style={{
                                                                color: "black",
                                                              }}
                                                            >
                                                              Total Amount
                                                            </h6>
                                                            <h6
                                                              style={{
                                                                color: "red",
                                                              }}
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={faEuroSign}
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  marginRight:
                                                                    "5px",
                                                                }}
                                                              ></FontAwesomeIcon>
                                                              {totalAmountAgent.toFixed(
                                                                2
                                                              )}
                                                            </h6>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                          </>
                        )}
                    </div>
                  ) : (
                    <> </>
                  )}

                  {this.state.Agent == true ? (
                    <div className="myTripLstngLobCrd forUpcoming">
                      {this.state.agentData == "noAgent" ? (
                        <div className="emptyErr">
                          <div className="emptyErr--imgCont">
                            <img src={EmptyImage} alt="Upcoming Image" />
                          </div>
                          <div>
                            <p className="emptyErr--heading font22 latoBlack appendBottom15">
                              Looks empty, you've no agent bookings.
                            </p>
                            <p className="emptyErr--subHeading fomt14 darkGreyText appendBottom25">
                              When you book a trip, you will see your itinerary
                              here.
                            </p>
                            <p>
                              <a href="/home">
                                <button className="font14 latoBold myTripBtn myTripBtn--primary ">
                                  Plan a trip
                                </button>
                              </a>
                            </p>
                          </div>
                        </div>
                      ) : (
                        <>
                          {this.state.agentData == null ? (
                            <>
                              <div
                                className="Container-Tile h-auto"
                              // style={{ height: 250 }}
                              >
                                <div className="ContainerFlex">
                                  <div
                                    className="ContainerImage"
                                    style={{ padding: "15px 10px 10px 10px" }}
                                  >
                                    <Skeleton
                                      style={{ width: "100%", height: "165px" }}
                                    />
                                  </div>
                                  <div
                                    className="ContainerContent"
                                    style={{ padding: "10px 10px 10px 40px" }}
                                  >
                                    <div
                                      className="nameContainer"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="paymakeFlex appendBottom5">
                                        <h3 className="latoBlack font22 blackText">
                                          <Skeleton
                                            style={{ width: "200px" }}
                                          />
                                        </h3>
                                        <span
                                          className="sRating"
                                          style={{
                                            display: "inline-flex",
                                            marginTop: "5px",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          <Skeleton
                                            style={{ width: "100px" }}
                                          />
                                        </span>
                                      </div>
                                      <p>
                                        <Skeleton style={{ width: "300px" }} />
                                      </p>
                                      <h3
                                        className="latoBlack font22 blackText"
                                        style={{
                                          marginTop: 10,
                                          fontSize: 18,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <Skeleton style={{ width: "150px" }} />
                                      </h3>

                                      <div class="chkContBooking">
                                        <div class="chkCont__col">
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText 444">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="chkCont__night">
                                            <span>
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {this.state.agentData.agent && (
                                <>
                                  {" "}
                                  {this.state.agentData.agent.agentbookingArr.map(
                                    (item, newindex) => {
                                      const Status = item.booking_status;
                                      let StatusMsg = "";
                                      if (Status == 1) {
                                        StatusMsg = "Booking confirmed";
                                      }
                                      const AgentbookingID = item.id;
                                      const totalAmountAgent = parseFloat(
                                        item.total.slice(5, 13)
                                      );
                                      const commistionPrice = parseFloat(
                                        item.commission_price
                                      );
                                      const MainPrice = parseFloat(
                                        totalAmountAgent + commistionPrice
                                      );

                                      let JsonStatePDFAcco = {
                                        booking_amount: MainPrice,
                                        paid_amount: totalAmountAgent,
                                        booking_refrence_id:
                                          item.booking_refrence_id,
                                        b_date: item.booking_date,
                                        numberof_night: 2,
                                        child: item.child,
                                        status: StatusMsg,
                                        agentdetails: this.state.AgentDetails,
                                      };
                                      const propertypdf = JSON.stringify(
                                        JsonStatePDFAcco
                                      );
                                      const packageDetails = packageForMyBookingFunc(item?.child);
                                      const isPackage = packageDetails.is_package;
                                      const package_name = packageDetails.package_name;
                                      return (
                                        <>
                                          <div className="Container-Tile h-auto">
                                            <div class="ContainerFlex">
                                              <div class="row">
                                                <div class="col-sm-8">
                                                  <div class="container">
                                                    <div class="row">
                                                      <div class="pricing-details">
                                                        <div className="price-breakup">
                                                          <div className="price-header">
                                                            {isPackage && <h6 className="text-black mb-1">Package Name: <span>{package_name}</span></h6>}
                                                            <h6
                                                              style={{
                                                                color:
                                                                  "black",
                                                              }}
                                                            >
                                                              <span>
                                                                Agent Booking
                                                                Ref No:-{" "}
                                                                {
                                                                  item.booking_refrence_id
                                                                }
                                                              </span>{" "}
                                                              <span
                                                                style={{
                                                                  float:
                                                                    "right",
                                                                }}
                                                              >
                                                                Booking Date-{" "}
                                                                {moment(
                                                                  item.booking_date
                                                                ).format(
                                                                  "D MMM Y"
                                                                )}
                                                              </span>
                                                            </h6>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="container px-4 text-center">
                                                        <div class="row gx-5">
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="paymentVoucher.pdf"
                                                                pdfDocument={<InvoiceAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                                paymentVoucher
                                                              />
                                                            </div>
                                                          </div>
                                                          <div class="col">
                                                            <div class="p-3">
                                                              <PaymentVoucherDownload
                                                                fileName="bookingVoucher.pdf"
                                                                pdfDocument={<BookingAgent
                                                                  invoice={
                                                                    propertypdf
                                                                  }
                                                                />}
                                                              />
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div
                                                        style={{
                                                          height: "180px",
                                                          overflowY: "auto",
                                                        }}
                                                      >
                                                        <table className="table">
                                                          <thead className="thead-dark">
                                                            <tr>
                                                              <th scope="col">
                                                                #
                                                              </th>
                                                              <th scope="col">
                                                                BookingId.
                                                              </th>
                                                              <th scope="col">
                                                                Item
                                                              </th>
                                                              <th scope="col">
                                                                Service Date
                                                              </th>
                                                              {!isPackage &&
                                                                <th scope="col">
                                                                  Amount
                                                                </th>}
                                                              <th scope="col">
                                                                Status
                                                              </th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            {item.child !=
                                                              null &&
                                                              item.child.map(
                                                                (
                                                                  bookingItem,
                                                                  indexNewData
                                                                ) => {
                                                                  const Statuschild =
                                                                    bookingItem.booking_status;
                                                                  let StatusMsgChild =
                                                                    "";
                                                                  if (
                                                                    Statuschild ==
                                                                    1
                                                                  ) {
                                                                    StatusMsgChild =
                                                                      "Booking Confirmed";
                                                                  } else if (
                                                                    Statuschild ==
                                                                    3
                                                                  ) {
                                                                    StatusMsgChild =
                                                                      "Booking Cancelled";
                                                                  } else if (
                                                                    Statuschild ==
                                                                    11
                                                                  ) {
                                                                    StatusMsgChild =
                                                                      "Booking Decline";
                                                                  } else if (
                                                                    Statuschild ==
                                                                    12
                                                                  ) {
                                                                    StatusMsgChild =
                                                                      "Booking Review";
                                                                  } else if (
                                                                    Statuschild ==
                                                                    13
                                                                  ) {
                                                                    StatusMsgChild =
                                                                      "Booking Error";
                                                                  } else {
                                                                    StatusMsgChild =
                                                                      "Payment Settled but Not Booked";
                                                                  }
                                                                  let bookingRefrence =
                                                                    bookingItem.booking_refrence_id;
                                                                  if (
                                                                    bookingItem.booking_source ==
                                                                    1
                                                                  ) {
                                                                    if (
                                                                      bookingItem.ReservationLocation !=
                                                                      null
                                                                    ) {
                                                                      bookingRefrence =
                                                                        bookingItem.booking_refrence_id +
                                                                        "-" +
                                                                        bookingItem.ReservationLocation;
                                                                    } else {
                                                                      bookingRefrence =
                                                                        bookingItem.booking_refrence_id;
                                                                    }
                                                                  } else if (
                                                                    bookingItem.booking_source ==
                                                                    2
                                                                  ) {
                                                                    bookingRefrence =
                                                                      bookingItem.booking_refrence_id +
                                                                      "-" +
                                                                      bookingItem.hl_booking_id;
                                                                  }

                                                                  return (
                                                                    <tr>
                                                                      <th scope="row">
                                                                        {indexNewData +
                                                                          1}
                                                                      </th>
                                                                      <td>
                                                                        {
                                                                          bookingRefrence
                                                                        }
                                                                      </td>
                                                                      <td>
                                                                        {" "}
                                                                        {
                                                                          bookingItem.rateplan_name
                                                                        }
                                                                        (
                                                                        {
                                                                          bookingItem.item_name
                                                                        }
                                                                        )
                                                                        <br />

                                                                        {bookingItem?.pickup_transfer && (`${bookingItem.pickup_transfer} to ${bookingItem.drop_transfer}`)}

                                                                      </td>
                                                                      <td>
                                                                        {bookingItem.type ==
                                                                          "accomodation"
                                                                          ? moment(
                                                                            bookingItem.booking_checked_in
                                                                          ).format(
                                                                            "D MMM Y"
                                                                          ) +
                                                                          " - " +
                                                                          moment(
                                                                            bookingItem.booking_checked_out
                                                                          ).format(
                                                                            "D MMM Y"
                                                                          )
                                                                          : moment(
                                                                            bookingItem.tour_booking_date
                                                                          ).format(
                                                                            "D MMM Y"
                                                                          )}
                                                                      </td>
                                                                      {!isPackage && <td>
                                                                        {parseFloat(
                                                                          bookingItem.total.slice(
                                                                            5,
                                                                            13
                                                                          )
                                                                        )}
                                                                      </td>}
                                                                      <td>
                                                                        {
                                                                          StatusMsgChild
                                                                        }
                                                                        {bookingItem?.cancel_by == 1 ? (<span className="cancelled-by-admin">Admin</span>) : (<></>)}
                                                                      </td>
                                                                      {/* <td>{bookingItem.type=='expreriance' ?(<>Expreriance</>):(<>Accomodation</>)}</td> */}
                                                                    </tr>
                                                                  );
                                                                }
                                                              )}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="col-sm-4">
                                                  <div class="pricing-details">
                                                    <div className="price-breakup">
                                                      <div className="price-header">
                                                        <h6
                                                          style={{
                                                            color: "black",
                                                          }}
                                                        >
                                                          Price Details
                                                        </h6>
                                                      </div>
                                                      <div className="total-amount">
                                                        <div>
                                                          <p>Price</p>
                                                        </div>
                                                        <div>
                                                          <p
                                                            className="latoBlack font26 blackText appendBottom5"
                                                            id="hlistpg_hotel_shown_price"
                                                          >
                                                            <span>€</span>
                                                            {MainPrice.toFixed(
                                                              2
                                                            )}
                                                          </p>
                                                        </div>
                                                      </div>

                                                      <div className="taxes">
                                                        <h6
                                                          style={{
                                                            color: "black",
                                                          }}
                                                        >
                                                          Less Agent Discount(
                                                          {
                                                            this.state
                                                              .Commission
                                                          }
                                                          %)
                                                        </h6>
                                                        <h6
                                                          style={{
                                                            color: "black",
                                                          }}
                                                        >
                                                          <span>€</span>
                                                          {commistionPrice.toFixed(
                                                            2
                                                          )}
                                                        </h6>
                                                      </div>
                                                      <div className="total-amount">
                                                        <h6
                                                          style={{
                                                            color: "black",
                                                          }}
                                                        >
                                                          Total Amount
                                                        </h6>
                                                        <h6
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faEuroSign}
                                                            style={{
                                                              fontSize:
                                                                "14px",
                                                              marginRight:
                                                                "5px",
                                                            }}
                                                          ></FontAwesomeIcon>
                                                          {totalAmountAgent.toFixed(
                                                            2
                                                          )}
                                                        </h6>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <BackDropComponent open={this.state.backDrop} />
      </div>
    );
  }
}

export default PlanTrips;
